import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import 'contents/assets/scss/page/student.scss';

function SatisfactionExternal() {
  const [modalOpen, setModalOpen] = useState(true);
  return (
    <main className="com_container">
      <Modal open={modalOpen} close={() => setModalOpen(false)} type="pop_class_select_external">
        <h2 className="pop_tit">배정 요청서 선택</h2>
				{/* 20250218 퍼블 추가&수정 */}
				<button type="button" className="btn_close"></button>
        <div className="content_container scroll">
          <table className="com_board_list">
            <colgroup>
              <col width="35%" />
              <col width="20%" />
              <col width="45%" />
            </colgroup>
            <thead>
              <tr>
                <th>교사명</th>
                <th>무배정 기간</th>
                <th>배정 요청서 선택</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>김길동 (010-13245-1324)</td>
                <td>1년 124일</td>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">배정요청서</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">수업진행 요청서</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>김길동 (010-13245-1324)</td>
                <td>2년 78일</td>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">배정요청서</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">수업진행 요청서</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>김길동 (010-13245-1324)</td>
                <td>1년 124일</td>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">배정요청서</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">수업진행 요청서</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">보내기</button>
        </div>
      </Modal>
    </main>
  );
}

export default SatisfactionExternal;
